/**
 * 项目状态管理常量
 */

/** 防抖延迟 (毫秒) */
export const 保存防抖延迟 = 500

/** 缩略图默认尺寸 */
export const 默认缩略图尺寸 = 200

/** 缩略图质量 */
export const 缩略图质量 = 0.8

/** 缩略图格式 */
export const 缩略图格式 = 'image/webp'
